/**
 * @prettier
 * @flow
 */
import type { Environment } from 'src/constants/Environment';
import { Environments } from 'src/constants/Environment';

export function terminalApiUrl(environment: Environment): string {
    switch (environment) {
        case Environments.LOCALHOST:
            return 'http://localhost:7071';
        case Environments.TEST:
            return 'https://api-terminal-test.azurewebsites.net';
        case Environments.PROD:
            return 'https://api-terminal.azurewebsites.net';
        default:
            throw new Error(`Invalid argument environment=${environment}`);
    }
}
